<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='work-order-grid'>
        <dx-data-grid ref='refWorkOrderGrid'
          :data-source='workOrderInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          @focused-row-changed="onSelectionChanged"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          @toolbar-preparing='onToolbarPreparing'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="false"
            file-name=""
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            width="90"
            :buttons="editButtons"
            type="buttons"
          />
          <DxColumn
            :allowEditing='false'
            :fixed="true"
            caption="작업번호"
            data-field="seqId"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="품목유형"
            data-field="품목유형"
            :visible='true'
          >
            <DxLookup
              :data-source="goodsLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="true"
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="품명"
            data-field="품명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="라인명"
            data-field="라인명"
            :visible='true'
            sort-order='asc'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="시작시간"
            data-field="생산시작시간"
            dataType= 'datetime'
            format='yyyy-MM-dd HH:mm'
            sort-order='asc'
            width = '120'>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="종료시간"
            data-field="생산종료시간"
            dataType= 'datetime'
            format='yyyy-MM-dd HH:mm'
            width = '120'>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="계획수량"
            data-field="수량"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="seqId"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
      <div class='work-output-grid' style="margin-top:10px;">
        <dx-data-grid ref='refWorkoutputGrid'
          :data-source='workOutputInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridSubHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          @focused-row-changed="onSelectionChangedSub"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          :focused-row-key.sync='focusedRowKey'
          @row-inserted='onRowInserted' @row-inserting='onRowInserting'
          @row-updated='onRowUpdated' @row-updating="onRowUpdating"
          @editor-preparing='onEditorPreparing'
          @init-new-row='onInitNewRow'
          @toolbar-preparing='onToolbarPreparingSub'
          @cell-prepared='onCellPreparedOutput'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="workOutputTitle"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="false"
            :allow-updating="true"
            :allow-adding="false"
            :use-icons="true"
            mode='popup'
          >
            <DxPopup
              :show-title="true"
              :width="600"
              :height="300"
              :title="ouputRegTitle"
            >
              <dx-position
                my="center"
                at="center"
                of="window"
              />
            </DxPopup>
            <DxForm>
              <DxItem
                :col-count="2"
                :col-span="2"
                item-type="group"
              >
                <DxItem data-field="라인명"/>
                <DxItem data-field="성명"/>
                <DxItem data-field="품명"/>
                <DxItem data-field="생산구분"/>
                <DxItem data-field="시작시간"/>
                <DxItem data-field="종료시간"/>
                <DxItem data-field="양품"/>
                <DxItem data-field="불량" />
              </DxItem>
              <DxItem
                :col-count="1"
                :col-span="2"
                item-type="group"
              >
                <DxItem data-field="비고"/>
              </DxItem>
            </DxForm>
          </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            width="90"
            :buttons="editSubButtons"
            type="buttons"
          />
          <DxColumn
            :allowEditing='isIdEdit'
            :fixed="true"
            caption="품번"
            data-field="품번"
            edit-cell-template="productionGridTemplate"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            :fixed="true"
            caption="품명"
            data-field="품명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="품목유형"
            data-field="품목유형"
            :visible='true'
          >
            <DxLookup
              :data-source="goodsLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='isRegLineStop'
            caption="생산구분"
            data-field="생산구분"
            :visible='true'
          >
            <dx-required-rule message="항목을 입력하세요"/>
            <DxLookup
              :data-source="outputStatusLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="라인명"
            data-field="라인명"
            :visible='true'
            edit-cell-template="lineGridTemplate"
            sort-order='asc'
          >
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing="(!copyOutput && isIdEdit) || isFromOrderNo"
            caption="시작시간"
            data-field="시작시간"
            dataType= 'datetime'
            format='yyyy-MM-dd HH:mm'
            width = '120'
            sort-order='asc'>
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing="isIdEdit || isFromOrderNo"
            caption="종료시간"
            data-field="종료시간"
            dataType= 'datetime'
            format='yyyy-MM-dd HH:mm'
            width = '120'>
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='!isRegLineStop'
            caption="양품"
            data-field="양품"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='!isRegLineStop'
            caption="불량"
            data-field="불량"
            :visible='true'
            format='#,##0'
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="생산(반)"
            data-field="부서명"
            :visible='true'
          >
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="작업자"
            data-field="성명"
            :visible='true'
            edit-cell-template="employeeGridTemplate"
          >
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="비고"
            data-field="비고"
            :visible='true'
          >
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="품번"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
          <template #lineGridTemplate="{ data: cellInfo }">
            <LineGridComponent
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              @selected-line='setLineCode'
              :lineInfo='lineList'
              @value-changed='onLineInfoValueChanged'
              :isEdit='!copyOutput'
            />
          </template>
          <template #employeeGridTemplate="{ data: cellInfo }">
            <EmployeeGridComponent
              ref="employeeComponent"
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              @selected-sabun='setSabunCode'
              :gridInfo='employeeList'
            />
          </template>
          <template #productionGridTemplate="{ data: cellInfo }">
            <ProductionGridComponent
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              @selected-pcode='setProductionCode'
              :productionInfo='productionList'
              :isEdit='isIdEdit'
            />
          </template>
          <template #output-grid-title>
            <div class="toolbar-label" style='font-size:1.2rem;margin-left:0px;'>
              <b>{{workOutputTitle}}</b>
            </div>
          </template>
        </dx-data-grid>
      </div>
      <DxPopupGen
        :visible.sync="popupWorkTime"
        :drag-enabled="true"
        :close-on-outside-click="true"
        :show-title="true"
        :width="480"
        :height="200"
        title="작업시간 선택"
      >
        <div style='position:relative;'>
          <div class="dx-field">
            <div class="dx-field-label">근무조건:</div>
            <div class="dx-field-value">
              <DxRadioGroup
                :items="workType"
                :value="workType[0]"
                layout="horizontal"
                @value-changed="OnChangeSelectionWorkType"
              />
            </div>
          </div>
          <div class="dx-field" v-if="selectedWorkType === 1">
            <div class="dx-field-label">근무시간대:</div>
            <div class="dx-field-value">
              <DxRadioGroup
                :items="workTime2"
                :value.sync="selectedWorkTime2"
                layout="horizontal"
              />
            </div>
          </div>
          <div class="dx-field" v-if="selectedWorkType === 2">
            <div class="dx-field-label">근무시간대:</div>
            <div class="dx-field-value">
              <DxRadioGroup
                :items="workTime3"
                :value.sync="selectedWorkTime3"
                layout="horizontal"
              />
            </div>
          </div>
          <div style='position:absolute; top: 100px; right: 0px'>
            <DxButton
              text='확인'
              width='168'
              @click="onWorkTypeConfirm"
            />
          </div>
        </div>
      </DxPopupGen>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxForm, DxLookup,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxItem } from 'devextreme-vue/form'
import ProductionGridComponent from '../../share/component/ProductionGridComponent'
import LineGridComponent from '../../share/component/LineGridComponent'
import EmployeeGridComponent from '../../share/component/EmployeeGridComponent'
import axios from 'axios'
import DxRadioGroup from 'devextreme-vue/radio-group'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import { DxButton } from 'devextreme-vue'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '일일 생산실적등록'
        }
      ],
      editButtons: [{
        hint: '생산실적 등록',
        icon: 'rowproperties',
        visible: 'true',
        onClick: this.onClickRegOutputFromOrder
      },
      {
        hint: '생산중단 등록',
        icon: 'download',
        visible: 'true',
        onClick: this.onClickRegLineStopFromOrder
      }],
      orderDate: null,
      workOrderInfoList: null,
      isIdEdit: true,
      lineList: null,
      productionList: null,
      employeeList: null,
      goodsLookup: null,
      selectedRowOrder: null,
      // ****** 실적 그리드 ************
      gridSubHeight: null,
      editSubButtons: ['edit',
        {
          hint: '생산실적 삭제',
          icon: 'trash',
          visible: 'true',
          onClick: this.onRowRemoving
        },
        {
          hint: '해당라인 생산실적 등록',
          icon: 'add',
          visible: 'true',
          onClick: this.onClickOutputStep
        },
        {
          hint: '해당라인 생산중단 등록',
          icon: 'download',
          visible: 'true',
          onClick: this.onClickLineStopStep
        }],
      workOutputTitle: null,
      workOutputInfoList: null,
      outputStatusLookup: null,
      isFromOrderNo: false,
      isRegLineStop: false,
      ouputRegTitle: '생산실적등록',
      selectedRowOutput: null,
      focusedRowKey: null,
      copyOutput: false,
      // popup popupWorkTime *******
      popupWorkTime: false,
      workType: [ ConstDef.근무형태[0].코드명, ConstDef.근무형태[1].코드명, ConstDef.근무형태[2].코드명 ],
      selectedWorkType: 0,
      workTime2: ['주간', '야간'],
      selectedWorkTime2: null,
      workTime3: ['주간조', '중간조', '야간조'],
      selectedWorkTime3: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxLookup,
    DxEditing,
    DxSearchPanel,
    DxForm,
    DxPopup,
    DxPosition,
    DxRequiredRule,
    DxItem,
    ProductionGridComponent,
    LineGridComponent,
    EmployeeGridComponent,
    // DxRadioGroup
    DxPopupGen,
    DxRadioGroup,
    DxButton
  },
  computed: {
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.orderDate = AppLib.calcDateFromToday(-1)
    this.workOutputTitle = `${this.orderDate} 생산실적`
    this.goodsLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.outputStatusLookup = this.$store.getters.getBaseDataByType(ConstDef.생산진행상태)
    this.refreshWorkOrder()
    this.refreshLine()
    this.refreshProduction()

    this.selectedWorkType = 0
    this.selectedWorkTime2 = this.workTime2[0]
    this.selectedWorkTime3 = this.workTime3[0]
  },
  mounted () {
    this.gridHeight = ((screen.height - 250) * 0.95) * 0.4
    this.gridSubHeight = ((screen.height - 250) * 0.95) * 0.6
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onClickRegLineStopFromOrder (e) {
      this.ouputRegTitle = '생산중단 등록'
      this.copyOutput = false
      this.isFromOrderNo = true
      this.isRegLineStop = true
      this.popupWorkTime = true
    },
    onClickRegOutputFromOrder (e) {
      this.ouputRegTitle = '생산실적 등록'
      this.copyOutput = false
      this.isFromOrderNo = true
      this.isRegLineStop = false
      this.popupWorkTime = true
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRowOrder = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>작업지시 기준일 : </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 120,
            value: this.orderDate,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              this.orderDate = args.value
              this.workOutputTitle = `${this.orderDate} 생산실적`
              this.refreshWorkOrder()
            }
          }
        }
      )
    },
    refreshEmployee (lineCode) {
      this.$_sp.runNoEncodeFindProc('spFindAllEmployeeBylineCode', { 라인코드: lineCode })
        .then((data) => {
          this.employeeList = this.$_sp.MakeModel(data)
          if (!this.copyOutput) {
            this.$refs.employeeComponent.initGrid()
          }
        })
    },
    refreshProduction () {
      this.$_sp.runNoEncodeFindProc('spFindAllProduction', {})
        .then((data) => {
          this.productionList = this.$_sp.MakeModel(data)
          console.log(this.productionList)
        })
    },
    refreshLine () {
      this.$_sp.runNoEncodeFindSqlProc('생산라인', null)
        .then((data) => {
          this.lineList = this.$_sp.MakeModel(data)
        })
    },
    refreshWorkOrder () {
      this.isLoading = true
      const order = this.$_sp.runNoEncodeFindProc('spFindAllWorkOrderByDate', { 생산기준일: this.orderDate })
      const output = this.$_sp.runNoEncodeFindProc('spFindAllWorkOutputByDate', { 생산기준일: this.orderDate })
      axios.all([order, output])
        .then(axios.spread((...reponse) => {
          this.isLoading = false
          this.workOrderInfoList = this.$_sp.MakeModel(reponse[0])
          this.workOutputInfoList = this.$_sp.MakeModel(reponse[1])
          console.log(this.workOutputInfoList)
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshWorkOutput () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllWorkOutputByDate', { 생산기준일: this.orderDate })
        .then((data) => {
          this.isLoading = false
          this.workOutputInfoList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // ************ 생산실적 그리드 ***************************
    // ************ 생산실적 그리드 ***************************
    // ************ 생산실적 그리드 ***************************
    checkStartEndTime (row) {
      if (row.data.시작시간 !== null && (typeof row.data.시작시간) === 'object') {
        row.data.시작시간 = row.data.시작시간.getTime()
      }
      if (row.data.종료시간 !== null && (typeof row.data.종료시간) === 'object') {
        row.data.종료시간 = row.data.종료시간.getTime()
      }
      if ((row.data.종료시간 !== null && row.data.시작시간 !== undefined) && row.data.종료시간 <= row.data.시작시간) {
        this.$snotify.error('종료시간은 시작시간보다 커야 합니다.')
        row.cancel = true
        return
      }
      let where = this.$_.where(this.workOutputInfoList, { 라인코드: this.selectedLineCode, 생산반: row.data.생산반 })
      if (where.length > 0) {
        where = this.$_.sortBy(where, '시작시간')
        if (where[where.length - 1].종료시간 !== row.data.시작시간) {
          this.$snotify.error('시작시간이 마지막 입력한 라인의 종료시간과 동일한 시간으로 입력하여야 합니다.')
          row.cancel = true
        }
      }
    },
    onCellPreparedOutput (e) {
      if (e.rowType === 'data' && e.column.dataField === '생산구분') {
        if (e.data.생산구분 !== ConstDef.생산라인정상) { // 재공재고
          this.$Q(e.cellElement).css('color', 'red')
        }
      }
    },
    onEditorPreparing (e) {
      if (e.dataField === '생산구분' && e.row !== undefined) {
        if (e.row.isNewRow === true && this.isFromOrderNo === false) {
          this.isIdEdit = true
        } else {
          if (e.value === ConstDef.생산라인정상) {
            console.log(e.value)
            this.isRegLineStop = false
          } else {
            this.isRegLineStop = true
          }
          this.isIdEdit = false
        }
      }
    },
    onClickLineStopStep (e) {
      this.ouputRegTitle = '생산중단 등록'
      this.selectedRowOutput = e.row.data
      this.isRegLineStop = true
      this.copyOutput = true
      this.isFromOrderNo = false
      this.$refs.refWorkoutputGrid.instance.addRow()
    },
    onClickOutputStep (e) {
      this.ouputRegTitle = '생산실적 등록'
      this.selectedRowOutput = e.row.data
      this.copyOutput = true
      this.isRegLineStop = false
      this.isFromOrderNo = false
      this.$refs.refWorkoutputGrid.instance.addRow()
    },
    onInitNewRow (row) {
      const overTime = parseInt(this.$_.findWhere(this.$store.getters.getSysParam, { key: '잔업시간' }).value)
      let startTime = null
      let endTime = null
      if (this.copyOutput === false) {
        switch (this.selectedWorkType) {
          case 0:
            startTime = `${this.orderDate} ${this.$_.findWhere(this.$store.getters.getSysParam, { key: '주간생산시작시간' }).value}`
            endTime = AppLib.getTimestampFromString(`${startTime}:00`)
            endTime = AppLib.formatDateTimeFromTimeStamp(endTime + (9 * 3600 * 1000 + overTime * 3600 * 1000))
            break
          case 1: // 2교대
            if (this.selectedWorkTime2 === '주간') {
              startTime = `${this.orderDate} ${this.$_.findWhere(this.$store.getters.getSysParam, { key: '주간생산시작시간' }).value}`
              endTime = AppLib.getTimestampFromString(`${startTime}:00`)
              endTime = AppLib.formatDateTimeFromTimeStamp(endTime + (9 * 3600 * 1000 + overTime * 3600 * 1000))
            } else {
              startTime = `${this.orderDate} ${this.$_.findWhere(this.$store.getters.getSysParam, { key: '야간생산시작시간' }).value}`
              endTime = AppLib.getTimestampFromString(`${startTime}:00`)
              endTime = AppLib.formatDateTimeFromTimeStamp(endTime + (9 * 3600 * 1000 + overTime * 3600 * 1000))
            }
            break
          case 2: // 3교대
            if (this.selectedWorkTime2 === '주간조') {
              startTime = `${this.orderDate} ${this.$_.findWhere(this.$store.getters.getSysParam, { key: '주간생산시작시간' }).value}`
              endTime = AppLib.getTimestampFromString(`${startTime}:00`)
              endTime = AppLib.formatDateTimeFromTimeStamp(endTime + (8 * 3600 * 1000))
            } else if (this.selectedWorkTime2 === '중간조') {
              startTime = `${this.orderDate} ${this.$_.findWhere(this.$store.getters.getSysParam, { key: '주간생산시작시간' }).value}`
              endTime = AppLib.getTimestampFromString(`${startTime}:00`)
              startTime = AppLib.formatDateTimeFromTimeStamp(endTime + (8 * 3600 * 1000))
              endTime = AppLib.getTimestampFromString(`${startTime}:00`)
              endTime = AppLib.formatDateTimeFromTimeStamp(endTime + (8 * 3600 * 1000))
            } else {
              startTime = `${this.orderDate} ${this.$_.findWhere(this.$store.getters.getSysParam, { key: '주간생산시작시간' }).value}`
              endTime = AppLib.getTimestampFromString(`${startTime}:00`)
              startTime = AppLib.formatDateTimeFromTimeStamp(endTime + (16 * 3600 * 1000))
              endTime = AppLib.getTimestampFromString(`${startTime}:00`)
              endTime = AppLib.formatDateTimeFromTimeStamp(endTime + (8 * 3600 * 1000))
            }
            break
        }
        row.data.시작시간 = AppLib.getTimestampFromString(`${startTime}:00`)
        row.data.종료시간 = AppLib.getTimestampFromString(`${endTime}:00`)
        row.data.생산기준일 = this.orderDate
        row.data.불량 = 0
        if (this.isFromOrderNo) {
          this.setProductionCode(this.selectedRowOrder.품번)
          row.data.품번 = this.selectedRowOrder.품번
          row.data.품명 = this.selectedRowOrder.품명
          row.data.작업지시번호 = this.selectedRowOrder.작업지시번호
          row.data.라인명 = this.selectedRowOrder.라인명
          this.setLineCode(this.selectedRowOrder.라인코드)
          this.refreshEmployee(this.selectedRowOrder.라인코드)
        }
        if (this.isRegLineStop === false) {
          row.data.생산구분 = ConstDef.생산라인정상
        } else {
          row.data.양품 = 0
        }
      } else {
        row.data.생산기준일 = this.orderDate
        row.data.불량 = 0
        row.data.종료시간 = row.data.시작시간 = this.selectedRowOutput.종료시간
        row.data.작업지시번호 = this.selectedRowOutput.작업지시번호
        row.data.라인명 = this.selectedRowOutput.라인명
        row.data.성명 = this.selectedRowOutput.성명
        console.log(row.data.성명)
        row.data.작업자사번 = this.selectedRowOutput.작업자사번
        this.setSabunCode(row.data.작업자사번)
        this.setLineCode(this.selectedRowOutput.라인코드)
        this.refreshEmployee(this.selectedRowOutput.라인코드)
        if (this.isRegLineStop === false) {
          row.data.생산구분 = ConstDef.생산라인정상
        } else {
          row.data.양품 = 0
          row.data.품번 = this.selectedRowOutput.품번
          row.data.품명 = this.selectedRowOutput.품명
          this.setProductionCode(row.data.품번)
        }
      }
    },
    onRowInserted (row) {
      this.isLoading = true
      this.$_sp.runInsertAndFindSqlProc('생산실적', ['생산기준일', '품번', 'createtime'], ['seqId', '품명', '라인명', '부서명', '품목유형', '성명'], row.data)
        .then((data) => {
          this.isLoading = false
          this.focusedRowKey = row.data.seqId = this.$_sp.MakeModel(data)[0].seqId
          this.$refs.refWorkoutputGrid.instance.refresh()
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowInserting (row) {
      row.data.updatetime = row.data.createtime = AppLib.getNow()
      row.data.updateid = row.data.createid = this.userInfo.userName
      row.data.작업자사번 = this.selectedSabun
      row.data.생산반 = this.$_.findWhere(this.employeeList, { 사번: this.selectedSabun }).부서코드
      row.data.부서명 = this.$_.findWhere(this.employeeList, { 사번: this.selectedSabun }).부서명
      row.data.라인코드 = this.selectedLineCode
      row.data.품목유형 = this.$_.findWhere(this.productionList, { 품번: row.data.품번 }).품목유형
      console.log(row.data)
      this.checkStartEndTime(row)
    },
    onRowRemoved (row) {
      this.isLoading = true
      this.$_sp.runUpdateProc('spDeleteOutputByDateAndLineCodeAndStartTime', [{ 생산기준일: row.data.생산기준일, 라인코드: row.data.라인코드, 시작시간: row.data.시작시간 }])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('삭제 되었습니다.')
          this.refreshWorkOutput()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemoving (e) {
      this.selectedRowOutput = e.row.data
      this.$snotify.confirm(`해당라인의 시작시간 ${AppLib.formatDateTimeFromTimeStamp(e.row.data.시작시간)}보다 큰 행은 모두 삭제 됩니다.`, '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '삭제',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.onRowRemoved(e.row)
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    onRowUpdated (row) {
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()
      this.isLoading = true
      this.$_sp.runUpdateSqlProc('생산실적', ['seqId'], ['품명', '라인명', '부서명', '품목유형', '성명'], [row.data])
        .then((data) => {
          this.isLoading = false
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {
      console.log(row)
      if (row.newData.생산구분 !== undefined && row.newData.생산구분 === ConstDef.생산라인정상 && row.oldData.양품 === 0 && row.oldData.불량 === 0) {
        this.$snotify.error('생산중단 정보 수정에서는 제품생산을 선택할 수 없습니다.')
        row.cancel = true
      }
    },
    onSelectionChangedSub (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRowOutput = e.row.data
      }
    },
    onToolbarPreparingSub (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'output-grid-title'
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '추가',
            icon: 'add',
            text: '생신실적 등록',
            type: 'success',
            focusStateEnabled: true,
            onClick: (args) => {
              this.ouputRegTitle = '생산실적 등록'
              this.copyOutput = false
              this.isFromOrderNo = false
              this.isRegLineStop = false
              this.popupWorkTime = true
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '추가',
            icon: 'download',
            text: '생산중단 등록',
            type: 'danger',
            focusStateEnabled: true,
            onClick: (args) => {
              this.ouputRegTitle = '생산중단 등록'
              this.copyOutput = false
              this.isFromOrderNo = false
              this.isRegLineStop = true
              this.popupWorkTime = true
            }
          }
        }
      )
    },
    // POPUOP ******************
    OnChangeSelectionWorkType (e) {
      console.log(e)
      this.selectedWorkType = this.$_.indexOf(this.workType, e.value)
    },
    onWorkTypeConfirm (e) {
      this.popupWorkTime = false
      this.$refs.refWorkoutputGrid.instance.addRow()
    },
    // emit compnay search
    setLineCode (code) {
      this.selectedLineCode = code
    },
    onLineInfoValueChanged (lineCode) {
      this.refreshEmployee(lineCode)
    },
    setSabunCode (code) {
      this.selectedSabun = code
    },
    setProductionCode (code) {
      this.selectedProductionCode = code
    }
  }
}
</script>

<style lang="scss">

</style>
